import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ProductImagesModule } from 'src/app/components/product-images/product-images.module';
import { AppTableModule } from 'src/app/components/table/app-table.module';
import { CustomizationRoutingModule } from './customization-routing.module';
import { MenuComponent } from './menu/menu.component';

// primeng
import { AccordionModule } from 'primeng/accordion';
import { ConfirmationService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { CarouselModule } from 'primeng/carousel';
import { CascadeSelectModule } from 'primeng/cascadeselect';
import { ColorPickerModule } from 'primeng/colorpicker';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { EditorModule } from 'primeng/editor';
import { FileUploadModule } from 'primeng/fileupload';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { ListboxModule } from 'primeng/listbox';
import { ChartModule } from 'primeng/chart';
import { MessageModule } from 'primeng/message';
import { OrderListModule } from 'primeng/orderlist';
import { PanelModule } from 'primeng/panel';
import { RadioButtonModule } from 'primeng/radiobutton';
import { TagModule } from 'primeng/tag';
import { TabViewModule } from 'primeng/tabview';
import { ToastModule } from 'primeng/toast';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { ChipsModule } from 'primeng/chips';

// own-brands
import { GlamBeautyComponent } from './own-brands/glam-beauty/glam-beauty.component';
import { MalmoComponent } from './own-brands/malmo/malmo.component';
import { MensComponent } from './own-brands/mens/mens.component';

// lps
import { LpClubBannersFormComponent } from './glam/lp-club/lp-club-banners/lp-club-banners-form/lp-club-banners-form.component';
import { LpClubBannersComponent } from './glam/lp-club/lp-club-banners/lp-club-banners.component';

import { AutoCompleteModule } from 'primeng/autocomplete';
import { BadgeModule } from 'primeng/badge';
import { BlockUIModule } from 'primeng/blockui';
import { CardModule } from 'primeng/card';
import { CheckboxModule } from 'primeng/checkbox';
import { ChipModule } from 'primeng/chip';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { FieldsetModule } from 'primeng/fieldset';
import { ImageModule } from 'primeng/image';
import { InputSwitchModule } from 'primeng/inputswitch';
import { MultiSelectModule } from 'primeng/multiselect';
import { PickListModule } from 'primeng/picklist';
import { TableModule } from 'primeng/table';
import { SkeletonModule } from 'primeng/skeleton';
import { SplitButtonModule } from 'primeng/splitbutton';
import { TooltipModule } from 'primeng/tooltip';
import { GridstackModule } from 'src/app/components/gridstack/gridstack.module';
import { CustomizationComponentBannerFormComponent } from './customization-component/customization-component-banner/customization-component-banner-form/customization-component-banner-form.component';
import { CustomizationComponentBannerComponent } from './customization-component/customization-component-banner/customization-component-banner.component';
import { CustomizationComponentComponent } from './customization-component/customization-component.component';
import { DmsBannerFormComponent } from './dms-section-form/dms-banner-form/dms-banner-form.component';
import { DmsSectionFormComponent } from './dms-section-form/dms-section-form.component';
import { CollectionsLojinhasEditComponent } from './glam/collections-lojinhas/collections-lojinhas-edit/collections-lojinhas-edit.component';
import { CollectionsLojinhasComponent } from './glam/collections-lojinhas/collections-lojinhas.component';
import { EditionComponent } from './glam/editions/edition/edition.component';
import { EditionsComponent } from './glam/editions/editions.component';
import { GlamCampaignsFormComponent } from './glam/glam-campaigns/glam-campaigns-form/glam-campaigns-form.component';
import { GlamCampaignsPostFormComponent } from './glam/glam-campaigns/glam-campaigns-post-form/glam-campaigns-post-form.component';
import { GlamCampaignsComponent } from './glam/glam-campaigns/glam-campaigns.component';
import { GlamHomeAnuncyFormComponent } from './glam/glam-home/glam-home-anuncy-form/glam-home-anuncy-form.component';
import { GlamHomeBannerAlertComponent } from './glam/glam-home/glam-home-banner-alert/glam-home-banner-alert.component';
import { GlamHomeBannerFormComponent } from './glam/glam-home/glam-home-banner-form/glam-home-banner-form.component';
import { GlamHomeCollectionFormComponent } from './glam/glam-home/glam-home-collection-form/glam-home-collection-form.component';
import { GlamHomeLiveEmbeddedFormComponent } from './glam/glam-home/glam-home-live-embedded-form/glam-home-live-embedded-form.component';
import { GlamHomeSectionComponent } from './glam/glam-home/glam-home-section/glam-home-section.component';
import { GlamHomeComponent } from './glam/glam-home/glam-home.component';
import { BannerFormComponent } from './glam/glam-new-home/banner-form/banner-form.component';
import { BrandsFormComponent } from './glam/glam-new-home/brands-form/brands-form.component';
import { CarouselFormComponent } from './glam/glam-new-home/carousel-form/carousel-form.component';
import { CollectionFormComponent } from './glam/glam-new-home/collection-form/collection-form.component';
import { GlamNewHomeComponent } from './glam/glam-new-home/glam-new-home.component';
import { HighligthsFormComponent } from './glam/glam-new-home/highligths-form/highligths-form.component';
import { InfobarFormComponent } from './glam/glam-new-home/infobar-form/infobar-form.component';
import { LiveFormComponent } from './glam/glam-new-home/live-form/live-form.component';
import { LpClubComponent } from './glam/lp-club/lp-club.component';
import { FirstPanelCarouselFormComponent } from './glam/panel/panel-first-carousel/panel-first-carousel-form/panel-first-carousel-form.component';
import { FirstPanelCarouselComponent } from './glam/panel/panel-first-carousel/panel-first-carousel.component';
import { SecondPanelCarouselFormComponent } from './glam/panel/panel-second-carousel/panel-second-carousel-form/panel-second-carousel-form.component';
import { SecondPanelCarouselComponent } from './glam/panel/panel-second-carousel/panel-second-carousel.component';
import { PanelComponent } from './glam/panel/panel.component';
import { VitrineCustomizationComponent } from './glam/vitrine-customization/vitrine-customization.component';
import { WishlistBannersFormComponent } from './glam/wishlist/wishlist-banners/wishlist-banners-form/wishlist-banners-form.component';
import { WishlistBannersComponent } from './glam/wishlist/wishlist-banners/wishlist-banners.component';
import { WishlistThemesFormComponent } from './glam/wishlist/wishlist-themes/wishlist-themes-form/wishlist-themes-form.component';
import { WishlistThemesComponent } from './glam/wishlist/wishlist-themes/wishlist-themes.component';
import { MensHomeNewAnuncyFormComponent } from './mens/mens-home-new/mens-home-new-anuncy-form/mens-home-new-anuncy-form.component';
import { MensHomeNewBannerAlertComponent } from './mens/mens-home-new/mens-home-new-banner-alert/mens-home-new-banner-alert.component';
import { MensHomeNewBannerFormComponent } from './mens/mens-home-new/mens-home-new-banner-form/mens-home-new-banner-form.component';
import { MensHomeNewCollectionFormComponent } from './mens/mens-home-new/mens-home-new-collection-form/mens-home-new-collection-form.component';
import { MensHomeNewLiveEmbeddedFormComponent } from './mens/mens-home-new/mens-home-new-live-embedded-form/mens-home-new-live-embedded-form.component';
import { MensHomeNewSectionComponent } from './mens/mens-home-new/mens-home-new-section/mens-home-new-section.component';
import { MensHomeNewComponent } from './mens/mens-home-new/mens-home-new.component';
import { MensHomeComponent } from './mens/mens-home/mens-home.component';
import { MensNewHomeBannerFormComponent } from './mens/mens-new-home/banner-form/banner-form.component';
import { MensNewHomeBrandsFormComponent } from './mens/mens-new-home/brands-form/brands-form.component';
import { MensNewHomeCarouselFormComponent } from './mens/mens-new-home/carousel-form/carousel-form.component';
import { MensNewHomeCollectionFormComponent } from './mens/mens-new-home/collection-form/collection-form.component';
import { MensNewHomeHighlightsFormComponent } from './mens/mens-new-home/highligths-form/highligths-form.component';
import { MensNewHomeInfobarFormComponent } from './mens/mens-new-home/infobar-form/infobar-form.component';
import { MensNewHomeLiveFormComponent } from './mens/mens-new-home/live-form/live-form.component';
import { MensNewHomeComponent } from './mens/mens-new-home/mens-new-home.component';
import { GlamBeautyBannerFormComponent } from './own-brands/glam-beauty/glam-beauty-carousel/glam-beauty-banner-form/glam-beauty-banner-form.component';
import { GlamBeautyCarouselComponent } from './own-brands/glam-beauty/glam-beauty-carousel/glam-beauty-carousel.component';
import { MalmoBannerFormComponent } from './own-brands/malmo/malmo-carousel/malmo-banner-form/malmo-banner-form.component';
import { MalmoCarouselComponent } from './own-brands/malmo/malmo-carousel/malmo-carousel.component';
import { MensBannerFormComponent } from './own-brands/mens/mens-carousel/mens-banner-form/mens-banner-form.component';
import { MensCarouselComponent } from './own-brands/mens/mens-carousel/mens-carousel.component';
import { ShoppingErrorDetailComponent } from './store/shopping-errors/shopping-error-detail/shopping-error-detail.component';
import { ShoppingErrorsComponent } from './store/shopping-errors/shopping-errors.component';
import { FormAfterCheckoutComponent } from './glam/form-after-checkout/form-after-checkout.component';

@NgModule({
  declarations: [
    LpClubComponent,
    LpClubBannersComponent,
    LpClubBannersFormComponent,
    GlamCampaignsComponent,
    GlamCampaignsFormComponent,
    GlamCampaignsPostFormComponent,
    MenuComponent,
    GlamBeautyComponent,
    GlamBeautyCarouselComponent,
    GlamBeautyBannerFormComponent,
    MalmoComponent,
    MalmoCarouselComponent,
    MalmoBannerFormComponent,
    MensComponent,
    MensCarouselComponent,
    MensBannerFormComponent,
    PanelComponent,
    FirstPanelCarouselComponent,
    SecondPanelCarouselComponent,
    FirstPanelCarouselFormComponent,
    SecondPanelCarouselFormComponent,
    VitrineCustomizationComponent,
    EditionsComponent,
    EditionComponent,
    WishlistThemesComponent,
    WishlistBannersComponent,
    WishlistThemesFormComponent,
    WishlistBannersFormComponent,
    CustomizationComponentComponent,
    CustomizationComponentBannerComponent,
    CustomizationComponentBannerFormComponent,
    GlamHomeComponent,
    GlamHomeBannerFormComponent,
    GlamHomeCollectionFormComponent,
    GlamHomeSectionComponent,
    MensHomeComponent,
    DmsSectionFormComponent,
    DmsBannerFormComponent,
    GlamHomeBannerAlertComponent,
    CollectionsLojinhasComponent,
    CollectionsLojinhasEditComponent,
    GlamHomeAnuncyFormComponent,
    GlamHomeLiveEmbeddedFormComponent,
    MensHomeNewComponent,
    MensHomeNewAnuncyFormComponent,
    MensHomeNewBannerAlertComponent,
    MensHomeNewBannerFormComponent,
    MensHomeNewSectionComponent,
    MensHomeNewCollectionFormComponent,
    MensHomeNewLiveEmbeddedFormComponent,
    ShoppingErrorsComponent,
    ShoppingErrorDetailComponent,
    GlamNewHomeComponent,
    LiveFormComponent,
    CarouselFormComponent,
    InfobarFormComponent,
    HighligthsFormComponent,
    CollectionFormComponent,
    BrandsFormComponent,
    BannerFormComponent,
    MensNewHomeComponent,
    MensNewHomeLiveFormComponent,
    MensNewHomeCarouselFormComponent,
    MensNewHomeInfobarFormComponent,
    MensNewHomeHighlightsFormComponent,
    MensNewHomeCollectionFormComponent,
    MensNewHomeBrandsFormComponent,
    MensNewHomeBannerFormComponent,
    FormAfterCheckoutComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    DragDropModule,
    InputTextareaModule,
    InputNumberModule,
    InputTextModule,
    ButtonModule,
    CascadeSelectModule,
    CustomizationRoutingModule,
    CalendarModule,
    FileUploadModule,
    CalendarModule,
    ColorPickerModule,
    ToggleButtonModule,
    ListboxModule,
    CalendarModule,
    RadioButtonModule,
    InputTextareaModule,
    ProductImagesModule,
    MessageModule,
    OrderListModule,
    AppTableModule,
    PanelModule,
    AccordionModule,
    DropdownModule,
    TagModule,
    EditorModule,
    ToastModule,
    TabViewModule,
    ChipsModule,
    ConfirmDialogModule,
    GridstackModule,
    CarouselModule,
    FieldsetModule,
    TooltipModule,
    BlockUIModule,
    ImageModule,
    ConfirmPopupModule,
    AutoCompleteModule,
    CardModule,
    CheckboxModule,
    InputSwitchModule,
    MultiSelectModule,
    SplitButtonModule,
    BadgeModule,
    SkeletonModule,
    ChipModule,
    PickListModule,
    TableModule,
    ChartModule,
    DialogModule
  ],
  providers: [ConfirmationService]
})
export class CustomizationModule {}
